import { totalEngage } from 'service/queries';
import { QueryTotalEngagementsArgs, TotalEngagement } from 'service/types/generated/backend_client_index';
import { GRAPHQL_CLIENT_NAMES } from 'service/constants';
import * as userService from 'services/user';
import { useQuery } from '../../utils';
import { QueryHookResponse } from '../../types/internal';

type useFetchTotalEngageSalesType = (args: QueryTotalEngagementsArgs) => QueryHookResponse<TotalEngagement>;

const useFetchTotalEngageSales: useFetchTotalEngageSalesType = ({ subdomain }) => {
  const token = userService.getToken();
  return useQuery<TotalEngagement>({
    query: totalEngage,
    variables: { subdomain },
    clientName: GRAPHQL_CLIENT_NAMES.BACKEND,
    requestHeaders: { Authorization: `Bearer ${token}` },
    handler: (res: any) => res,
    config: { revalidateOnMount: true },
  });
};

export default useFetchTotalEngageSales;
